<div class="container">
    <div class="header" *ngIf="formReady == 1 || formReady == 2">
        <h1>Solicite Su Préstamo</h1>
        <p><strong>APROBACIÓN RÁPIDA Y SENCILLA</strong></p>
        <p>Horario de Lunes a Viernes</p>
        <p>8:30 a.m. a 5:00 p.m.</p>
        <p>Oficina: (787) 979-3636</p>
        <p>Celular: (939) 310-8282</p>
    </div>
    <div class="firstForm" *ngIf="formReady == 1">
        <form [formGroup]="firstForm">
        <div class="formBody">
            <label class="form-labels mt-4">Nombre Completo</label>
            <div class="input-group">
                <input formControlName="name1" type="text" class="form-control" [(ngModel)]="formData.name">
            </div>

            <label class="form-labels mt-4">Email</label>
            <div class="input-group">
                <input formControlName="email1" type="text" class="form-control" [(ngModel)]="formData.email">
            </div>

            <label class="form-labels mt-4">Teléfono</label>
            <div class="input-group">
                <input formControlName="phone1" type="text" class="form-control" [(ngModel)]="formData.phone">
            </div>

            <label class="form-labels mt-4">Cantidad de su préstamo</label>
            <div class="input-group">
                <input formControlName="qty1" type="number" class="form-control" placeholder="entre $100 a $1,000" [(ngModel)]="formData.cantidad">
            </div>

            <label class="form-labels mt-4">Tipo de Financiamiento</label>
            <select formControlName="loan1" class="form-select" [(ngModel)]="formData.loanType">
                <option value="Prestamo Personal">Prestamo Personal</option>
                <option value="Financiamiento de Enseres">Financiamiento de Enseres</option>
                <option value="Creit Loan">Credit Loan</option>
            </select>

            <div class="mt-4">
                <h4><span style="color:red"><strong>ALERTA</strong></span> - La indagación de crédito que haremos se clasifica como un <strong>HARD INQUIRY</strong> y va a evidenciar todo su historial crediticio. Usted debe cumplir con los siguientes requisitos para el proceso de pre-cualificación. 
                    </h4>
                <ul>
                    <li>Si estuvo en quiebra, debe poder proveer su "Discharge"</li>
                    <li>Debe tener todas sus cuentas al día.</li>
                    <li>⁠Si tiene cuentas en pérdida que tengan 3 años o más, debe haber restablecido su crédito para cualificar.</li>
                    <li>Debe tener evidencia de ingresos estables durante los últimos 6 meses.</li>
                    <li>Si es mayor de 21 años y no tiene experiencia, podemos ayudarle.</li>
                </ul>
                <h5>Si usted entiende que <strong>NO</strong> cumple con los requisitos mencionados, tenemos otro <strong>TIPO DE PRÉSTAMO</strong> que le puede ayudar a rectificar su historial crediticio.</h5>
            </div>

            <button [disabled]="firstForm.invalid" class="btn btn-primary mt-4" (click)="firstFormSubmit()">Solicita Ahora</button>

        </div>
        </form>
        
    </div>

    <div class="secondForm" *ngIf="formReady == 2" >
        <div class="formBody">
            <form  [formGroup]="loanRequestForm" class="form-horizontal">
                <label class="form-labels mt-4">Propósito</label>
                <div class="input-group">
                    <input type="text" class="form-control" formControlName="proposito">
                </div>
            
                <label class="form-labels mt-2">Cantidad de Prestamo</label>
                <div class="input-group flex-nowrap">
                    <img class="input-group-text" width="40" src="./assets/icons/dollar.svg" />
                    <input type="number" [(ngModel)]="formData.cantidad" formControlName="cantidad" class="form-control">
                </div>
            
                <label class="form-labels mt-4">Tipo de Financiamiento</label>
                <select class="form-select" [(ngModel)]="formData.loanType" formControlName="loanType">
                    <option value="Prestamo Personal">Prestamo Personal</option>
                    <option value="Financiamiento de Enseres">Financiamiento de Enseres</option>
                    <option value="Credit Loan">Credit Loan</option>

                </select>
            
                <app-applicant [solicitante]="solicitante" (formReady)="addChildForm('solicitante', $event)"></app-applicant>
            
                <label class="form-labels mt-4">¿Como se enteró?</label>
                <select class="form-select" formControlName="comoSeEntero">
                    <option value="google">Google</option>
                    <option value="redes sociales">Redes Sociales</option>
                    <option value="referido">Referido</option>
                    <option value="billboard">Billboard</option>
                    <option value="flyer">Flyer</option>
                    <option value="otro">Otro</option>
                </select>
                
                <div class="mt-4">
                    <p>*VERIFIQUE que todos los espacios en blanco y botones estén completados.
                    </p>
                    <h4 style="color: red">AUTORIZACIÓN DE INVESTIGACIÓN DE CRÉDITO</h4>
                    <p>Al oprimir "Someter Información" ,autorizo a Central Credit, CORP a obtener, de las agencias de crédito aprobadas por el Estado Libre Asociado, los datos pertinentes para la evaluación de mi crédito en virtud de esta solicitud de préstamo. Autorizo a las entidades que se dedican a ofrecer información de crédito, a proveer a ustedes mis datos. Acepto que la solicitud es y quedará como propiedad de Central Credir, Corp, aunque no sea aprobada.</p>
                </div>
                <button class="btn btn-primary mt-4" (click)="secondFormSubmit()">Someter Información</button>
            </form>
        </div>
        
    </div>

    <div class="thankYou" *ngIf="formReady == 3">
        <h2>Gracias por someter su solicitud. Uno de nuestros representantes se comunicará con usted pronto.</h2>
        <a href="https://www.ccc-pr.com/" class="btn btn-primary mt-4">Volver a página de inicio</a>
    </div>



</div>